// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarCompromissosServicosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /agenda/buscar_compromissos_servicos/{compromisso_id}
 *
 * Returns the list of services for a compromisso. Reuses
 * Agenda_BuscarCompromissoServicoCompromissoRow because the per-row
 * shape comes from the same model method
 * (Compromissos_model::pega_servicos_compromisso) used by the singular
 * /agenda/buscar_compromisso endpoint.
 */
import type { Agenda_BuscarCompromissoServicoCompromissoRow } from './Agenda_BuscarCompromissoServicoCompromissoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarCompromissosServicosResponseDados {
servicos: Agenda_BuscarCompromissoServicoCompromissoRow[]
}

export type Agenda_BuscarCompromissosServicosResponse = ApiResponse<Agenda_BuscarCompromissosServicosResponseDados>;

registerResponseContract('Agenda_BuscarCompromissosServicosResponse', {
  servicos: {
    type: 'array',
    required: true,
    items: {
      servicoscategoria_id:              { type: 'number',  required: true },
      servico_id:                        { type: 'number',  required: true },
      compromisso_servico_id:            { type: 'number',  required: true },
      compromisso_id:                    { type: 'number',  required: false },
      orcamento_servico_id:              { type: 'number',  required: false },
      compromisso_servico_status:        { type: 'number',  required: true },
      compromisso_servico_valor:         { type: 'number',  required: true },
      compromisso_servico_qtd:           { type: 'number',  required: true },
      compromisso_servico_data_cadastro: { type: 'string',  required: false },
      compromisso_servico_observacao:    { type: 'string',  required: false },
      servico_nome:                      { type: 'string',  required: true },
      tem_imagens_antes:                 { type: 'boolean', required: false },
      tem_imagens_depois:                { type: 'boolean', required: false },
      imagens:                           { type: 'string',  required: false },
    },
  },
})
